export default __webpack_public_path__ + "static/media/church-example.1d55f94f.png";